export class PersonSearchPaginatedDTO {
  offset?: number;
  limit?: number;
  term!: string;
}
